import type { InferRequest } from '@/hooks/useApiClient'
import type { components } from '@/types/api/v1'
import { Popover, type PopoverProps } from 'antd'
import type { Dayjs } from 'dayjs'
import type { RangeValueType } from 'rc-picker/lib/PickerInput/RangePicker'
import type { ReactNode } from 'react'
import type { ScheduleItemWithConflicts } from '../Context/ScheduleItems/scheduleItemStore'
import { DriverScheduleItemForm } from '../Forms/DriverScheduleItem/DriverScheduleItemForm'
import { getDriverDefaultShiftTimes } from '../utils/getDefaultShift'

type Data = components['schemas']['DriverInfoRow']
type DriverCellPopoverProps = Omit<PopoverProps, 'content'> & {
  data: Data
  extraButtons?: ReactNode
  day?: string
  type?: 'AM Shift' | 'PM Shift' | string
  value?: ScheduleItemWithConflicts
  onSubmit: (val: InferRequest<'/driver/create_event'>) => void
  onDelete?: () => void
}

export function DriverCellPopover({
  data,
  type,
  value,
  day,
  extraButtons,
  onDelete,
  ...props
}: DriverCellPopoverProps) {
  const realType = type ?? value?.shift ?? undefined
  const mappedType = realType === 'am' ? 'AM Shift' : realType === 'pm' ? 'PM Shift' : realType
  const defaultDateRange: RangeValueType<Dayjs> = value
    ? [value.start, value.end]
    : getDriverDefaultShiftTimes(
        data,
        mappedType === 'AM Shift' ? 'am' : mappedType === 'PM Shift' ? 'pm' : undefined,
        day
      )
  return (
    <Popover
      trigger='click'
      {...props}
      open={props.open && !!mappedType}
      destroyTooltipOnHide
      content={
        <DriverScheduleItemForm
          driver={data}
          type={mappedType}
          id={value?.event_id ?? undefined}
          initialValue={{
            dateRange: defaultDateRange,
            tractor: {
              value: value?.tractor_id ?? data.tractor_id ?? undefined,
            },
            trailer: {
              value: value?.trailer_id ?? data.trailer_id ?? undefined,
            },
          }}
          extraButtons={extraButtons}
          onCancel={() => props.onOpenChange?.(false)}
          onDelete={onDelete}
          onSubmit={props.onSubmit}
        />
      }
    />
  )
}
